import { DeleteOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';

export const COLUMNS = deleteHandler => [
  {
    title: 'Название серии',
    dataIndex: 'serialName',
    render: (text, record) => {
      return <Space>{record.serial}</Space>;
    },
  },
  {
    title: 'Кол-во устройств в серии',
    dataIndex: 'devicesCount',
    render: (text, record) => {
      return (
        <Space>
          {record.alreadyRegisteredCount}/{record.deviceCount}
        </Space>
      );
    },
  },
  {
    title: 'Действия',
    key: 'action',
    render: (_, record) => (
      <Space size='small'>
        <Button danger type='link' icon={<DeleteOutlined />} onClick={async () => deleteHandler(record.id)}>
          Удалить
        </Button>
      </Space>
    ),
  },
];
